import { Alert } from "@apex/component-library/components/Alert/types";
import { Toast } from "@apex/component-library/components/Toast/types";

export const APP_ID = "MARGIN_PROCESSING";

export const INTERNAL_SERVER_ERROR_ALERT_CONFIG: Alert = {
  title: "System Unavailable",
  description:
    "Sorry, this service is temporarily unavailable. The request failed.",
  status: "error",
  direction: "row",
  isClosable: true,
  showIcon: true,
};

export const SUCCESS_TOAST: Toast = {
  title: "Success!",
  status: "success",
  duration: 8000,
  isClosable: true,
};

export const UNAUTHORIZED_ERROR_TOAST: Toast = {
  duration: null,
  isClosable: true,
  position: "top-right",
  showIcon: true,
  status: "error",
  title: "Unauthorized",
  variant: "left-accent",
};

export const DEFAULT_ERROR_TOAST: Toast = {
  duration: null,
  isClosable: true,
  position: "top-right",
  showIcon: true,
  status: "error",
  title: "The request failed",
  variant: "left-accent",
};
